<template>
  <component :is="tag" :class="classes">
    <slot/>
  </component>
</template>

<script>
export default {
  props: {
    typo: {
      type: String,
      default: 'body1'
    },
    tag: {
      type: String,
      default: 'p'
    }
  },
  computed: {
    classes () {
      return 'mdc-body mdc-typography--' + this.typo
    }
  }
}
</script>
